// extracted by mini-css-extract-plugin
export default {"base":"Edit_base__ELgl7","root":"Edit_root__bWV5A","content":"Edit_content__pyrcv","header":"Edit_header__sxUws","form":"Edit_form__iC5if"};